import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({
  theme: "light",
  accent: "pink",
  setTheme: () => {},
  setAccent: () => {},
});

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(
    () => localStorage.getItem("popu-theme") || "light"
  );
  const [accent, setAccentState] = useState(
    () => localStorage.getItem("popu-accent") || "pink"
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("popu-theme", theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute("data-popu-theme", accent);
    localStorage.setItem("popu-accent", accent);
  }, [accent]);

  return (
    <ThemeContext.Provider
      value={{
        theme,
        accent,
        setTheme: setThemeState,
        setAccent: setAccentState,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
